import { render, staticRenderFns } from "./ContributionsTable.vue?vue&type=template&id=93522c9a&scoped=true&"
import script from "./ContributionsTable.vue?vue&type=script&lang=js&"
export * from "./ContributionsTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/black-dashboard/views/_contributions.scss?vue&type=style&index=0&id=93522c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93522c9a",
  null
  
)

export default component.exports